module.exports = __webpack_public_path__ + "img/logo-cloud.202b34a6.svg";